import { getUserStorage } from './utils';

export const isApp = !!window.flutter_inappwebview;

export const isIosApp = (): boolean => {
  return (
    isApp &&
    /iphone|ipod|ipad|macintosh/.test(window.navigator.userAgent.toLowerCase())
  );
};

export const isAndroidApp = (): boolean => {
  return (
    isApp &&
    !/iphone|ipod|ipad|macintosh/.test(window.navigator.userAgent.toLowerCase())
  );
};

export const isPremium = (): boolean => {
  const user = getUserStorage();
  return user ? user.Charged : false;
};

export const isIosAppNotPremium = (): boolean => isIosApp() && !isPremium();
export const isIosAppPremium = (): boolean => isIosApp() && isPremium();
